// @flow
import type { Action } from './store.type';
import type {
  MergeValuesTypesType,
  MergeValuesRulesByTypeType,
  MergeValuesRuleType
} from 'src/models/merge-values';

export const GET_MERGE_VALUES_TYPES_REQUEST = 'GET_MERGE_VALUES_TYPES_REQUEST';
type GET_MERGE_VALUES_TYPES_REQUEST_TYPE = 'GET_MERGE_VALUES_TYPES_REQUEST';

export const GET_MERGE_VALUES_TYPES_SUCCESS = 'GET_MERGE_VALUES_TYPES_SUCCESS';
type GET_MERGE_VALUES_TYPES_SUCCESS_TYPE = 'GET_MERGE_VALUES_TYPES_SUCCESS';

export const GET_MERGE_VALUES_TYPES_FAILURE = 'GET_MERGE_VALUES_TYPES_FAILURE';
type GET_MERGE_VALUES_TYPES_FAILURE_TYPE = 'GET_MERGE_VALUES_TYPES_FAILURE';

export const DELETE_MERGE_VALUES_TYPE_REQUEST = 'DELETE_MERGE_VALUES_TYPE_REQUEST';
type DELETE_MERGE_VALUES_TYPE_REQUEST_TYPE = 'DELETE_MERGE_VALUES_TYPE_REQUEST';

export const DELETE_MERGE_VALUES_TYPE_SUCCESS = 'DELETE_MERGE_VALUES_TYPE_SUCCESS';
type DELETE_MERGE_VALUES_TYPE_SUCCESS_TYPE = 'DELETE_MERGE_VALUES_TYPE_SUCCESS';

export const DELETE_MERGE_VALUES_TYPE_FAILURE = 'DELETE_MERGE_VALUES_TYPE_FAILURE';
type DELETE_MERGE_VALUES_TYPE_FAILURE_TYPE = 'DELETE_MERGE_VALUES_TYPE_FAILURE';

export const UPDATE_MERGE_VALUES_TYPE_STATUS_REQUEST = 'UPDATE_MERGE_VALUES_TYPE_STATUS_REQUEST';
type UPDATE_MERGE_VALUES_TYPE_STATUS_REQUEST_TYPE = 'UPDATE_MERGE_VALUES_TYPE_STATUS_REQUEST';

export const UPDATE_MERGE_VALUES_TYPE_STATUS_SUCCESS = 'UPDATE_MERGE_VALUES_TYPE_STATUS_SUCCESS';
type UPDATE_MERGE_VALUES_TYPE_STATUS_SUCCESS_TYPE = 'UPDATE_MERGE_VALUES_TYPE_STATUS_SUCCESS';

export const UPDATE_MERGE_VALUES_TYPE_STATUS_FAILURE = 'UPDATE_MERGE_VALUES_TYPE_STATUS_FAILURE';
type UPDATE_MERGE_VALUES_TYPE_STATUS_FAILURE_TYPE = 'UPDATE_MERGE_VALUES_TYPE_STATUS_FAILURE';

export const GET_MERGE_VALUES_BY_TYPE_REQUEST = 'GET_MERGE_VALUES_BY_TYPE_REQUEST';
type GET_MERGE_VALUES_BY_TYPE_REQUEST_TYPE = 'GET_MERGE_VALUES_BY_TYPE_REQUEST';

export const GET_MERGE_VALUES_BY_TYPE_SUCCESS = 'GET_MERGE_VALUES_BY_TYPE_SUCCESS';
type GET_MERGE_VALUES_BY_TYPE_SUCCESS_TYPE = 'GET_MERGE_VALUES_BY_TYPE_SUCCESS';

export const GET_MERGE_VALUES_BY_TYPE_FAILURE = 'GET_MERGE_VALUES_BY_TYPE_FAILURE';
type GET_MERGE_VALUES_BY_TYPE_FAILURE_TYPE = 'GET_MERGE_VALUES_BY_TYPE_FAILURE';

export const SAVE_MERGE_VALUES_RULE_REQUEST = 'SAVE_MERGE_VALUES_RULE_REQUEST';
type SAVE_MERGE_VALUES_RULE_REQUEST_TYPE = 'SAVE_MERGE_VALUES_RULE_REQUEST';

export const SAVE_MERGE_VALUES_RULE_SUCCESS = 'SAVE_MERGE_VALUES_RULE_SUCCESS';
type SAVE_MERGE_VALUES_RULE_SUCCESS_TYPE = 'SAVE_MERGE_VALUES_RULE_SUCCESS';

export const SAVE_MERGE_VALUES_RULE_FAILURE = 'SAVE_MERGE_VALUES_RULE_FAILURE';
type SAVE_MERGE_VALUES_RULE_FAILURE_TYPE = 'SAVE_MERGE_VALUES_RULE_FAILURE';

export const DELETE_MERGE_VALUES_RULE_REQUEST = 'DELETE_MERGE_VALUES_RULE_REQUEST';
type DELETE_MERGE_VALUES_RULE_REQUEST_TYPE = 'DELETE_MERGE_VALUES_RULE_REQUEST';

export const DELETE_MERGE_VALUES_RULE_SUCCESS = 'DELETE_MERGE_VALUES_RULE_SUCCESS';
type DELETE_MERGE_VALUES_RULE_SUCCESS_TYPE = 'DELETE_MERGE_VALUES_RULE_SUCCESS';

export const DELETE_MERGE_VALUES_RULE_FAILURE = 'DELETE_MERGE_VALUES_RULE_FAILURE';
type DELETE_MERGE_VALUES_RULE_FAILURE_TYPE = 'DELETE_MERGE_VALUES_RULE_FAILURE';

export const UPDATE_MERGE_VALUES_RULE_STATUS_REQUEST = 'UPDATE_MERGE_VALUES_RULE_STATUS_REQUEST';
type UPDATE_MERGE_VALUES_RULE_STATUS_REQUEST_TYPE = 'UPDATE_MERGE_VALUES_RULE_STATUS_REQUEST';

export const UPDATE_MERGE_VALUES_RULE_STATUS_SUCCESS = 'UPDATE_MERGE_VALUES_RULE_STATUS_SUCCESS';
type UPDATE_MERGE_VALUES_RULE_STATUS_SUCCESS_TYPE = 'UPDATE_MERGE_VALUES_RULE_STATUS_SUCCESS';

export const UPDATE_MERGE_VALUES_RULE_STATUS_FAILURE = 'UPDATE_MERGE_VALUES_RULE_STATUS_FAILURE';
type UPDATE_MERGE_VALUES_RULE_STATUS_FAILURE_TYPE = 'UPDATE_MERGE_VALUES_RULE_STATUS_FAILURE';

export const RESET_MERGE_VALUE_ITEM = 'RESET_MERGE_VALUE_ITEM';
type RESET_MERGE_VALUE_ITEM_TYPE = 'RESET_MERGE_VALUE_ITEM';
type MergeValuesTypesSuccess = {
  data: {
    data: MergeValuesTypesType,
    scheduleSyncAfter: number,
    scheduleSyncIn: number,
    waitSyncAt: number
  }
};

type MergeValuesSuccess = {
  data: {
    data: MergeValuesRulesByTypeType,
    scheduleSyncAfter: number,
    scheduleSyncIn: number,
    waitSyncAt: number
  }
};

type MergeValuesRuleSuccess = {
  data: {
    data: MergeValuesRuleType,
    scheduleSyncAfter: number,
    scheduleSyncIn: number,
    waitSyncAt: number
  },
  id?: string
};

type UpdateMergeValuesTypeSuccess = {
  data: { scheduleSyncAfter: number, scheduleSyncIn: number, waitSyncAt: number },
  type: string
};

type UpdateMergeValuesRuleSuccess = {
  data: { scheduleSyncAfter: number, scheduleSyncIn: number, waitSyncAt: number },
  id: string
};
type MergeValuesFailure = {
  error: any
};

type GetMergeValuesTypesRequestAction = Action<GET_MERGE_VALUES_TYPES_REQUEST_TYPE, null>;

type GetMergeValuesTypesSuccessAction = Action<
  GET_MERGE_VALUES_TYPES_SUCCESS_TYPE,
  MergeValuesTypesSuccess
>;

type GetMergeValuesTypesFailureAction = Action<
  GET_MERGE_VALUES_TYPES_FAILURE_TYPE,
  MergeValuesFailure
>;

type DeleteMergeValuesTypeRequestAction = Action<DELETE_MERGE_VALUES_TYPE_REQUEST_TYPE, null>;

type DeleteMergeValuesTypeSuccessAction = Action<
  DELETE_MERGE_VALUES_TYPE_SUCCESS_TYPE,
  UpdateMergeValuesTypeSuccess
>;

type DeleteMergeValuesTypeFailureAction = Action<
  DELETE_MERGE_VALUES_TYPE_FAILURE_TYPE,
  MergeValuesFailure
>;

type UpdateMergeValuesTypeStatusRequestAction = Action<
  UPDATE_MERGE_VALUES_TYPE_STATUS_REQUEST_TYPE,
  { type: string, status: string }
>;

type UpdateMergeValuesTypeStatusSuccessAction = Action<
  UPDATE_MERGE_VALUES_TYPE_STATUS_SUCCESS_TYPE,
  UpdateMergeValuesTypeSuccess
>;

type UpdateMergeValuesTypeStatusFailureAction = Action<
  UPDATE_MERGE_VALUES_TYPE_STATUS_FAILURE_TYPE,
  MergeValuesFailure & { type: string, status: string }
>;

type GetMergeValuesByTypeRequestAction = Action<GET_MERGE_VALUES_BY_TYPE_REQUEST_TYPE, null>;

type GetMergeValuesByTypeSuccessAction = Action<
  GET_MERGE_VALUES_BY_TYPE_SUCCESS_TYPE,
  MergeValuesSuccess
>;

type GetMergeValuesByTypeFailureAction = Action<
  GET_MERGE_VALUES_BY_TYPE_FAILURE_TYPE,
  MergeValuesFailure
>;

type SaveMergeValuesRuleRequestAction = Action<SAVE_MERGE_VALUES_RULE_REQUEST_TYPE, null>;

type SaveMergeValuesRuleSuccessAction = Action<
  SAVE_MERGE_VALUES_RULE_SUCCESS_TYPE,
  MergeValuesRuleSuccess
>;

type SaveMergeValuesRuleFailureAction = Action<
  SAVE_MERGE_VALUES_RULE_FAILURE_TYPE,
  MergeValuesFailure
>;

type DeleteMergeValuesRuleRequestAction = Action<DELETE_MERGE_VALUES_RULE_REQUEST_TYPE, null>;

type DeleteMergeValuesRuleSuccessAction = Action<
  DELETE_MERGE_VALUES_RULE_SUCCESS_TYPE,
  UpdateMergeValuesRuleSuccess
>;

type DeleteMergeValuesRuleFailureAction = Action<
  DELETE_MERGE_VALUES_RULE_FAILURE_TYPE,
  MergeValuesFailure
>;

type UpdateMergeValuesRuleStatusRequestAction = Action<
  UPDATE_MERGE_VALUES_RULE_STATUS_REQUEST_TYPE,
  { id: string, status: string }
>;

type UpdateMergeValuesRuleStatusSuccessAction = Action<
  UPDATE_MERGE_VALUES_RULE_STATUS_SUCCESS_TYPE,
  UpdateMergeValuesRuleSuccess
>;

type UpdateMergeValuesRuleStatusFailureAction = Action<
  UPDATE_MERGE_VALUES_RULE_STATUS_FAILURE_TYPE,
  MergeValuesFailure & { id: string, status: string }
>;
type ResetMergeValuesItemAction = Action<RESET_MERGE_VALUE_ITEM_TYPE, {}>;
export type MergeValuesAction =
  | GetMergeValuesTypesRequestAction
  | GetMergeValuesTypesSuccessAction
  | GetMergeValuesTypesFailureAction
  | DeleteMergeValuesTypeRequestAction
  | DeleteMergeValuesTypeSuccessAction
  | DeleteMergeValuesTypeFailureAction
  | UpdateMergeValuesTypeStatusRequestAction
  | UpdateMergeValuesTypeStatusSuccessAction
  | UpdateMergeValuesTypeStatusFailureAction
  | GetMergeValuesByTypeRequestAction
  | GetMergeValuesByTypeSuccessAction
  | GetMergeValuesByTypeFailureAction
  | SaveMergeValuesRuleRequestAction
  | SaveMergeValuesRuleSuccessAction
  | SaveMergeValuesRuleFailureAction
  | DeleteMergeValuesRuleRequestAction
  | DeleteMergeValuesRuleSuccessAction
  | DeleteMergeValuesRuleFailureAction
  | UpdateMergeValuesRuleStatusRequestAction
  | UpdateMergeValuesRuleStatusSuccessAction
  | UpdateMergeValuesRuleStatusFailureAction
  | ResetMergeValuesItemAction;

export type MergeValuesState = {
  getTypesLoading: boolean,
  getTypesSuccess: boolean,
  getLoading: boolean,
  getSuccess: boolean,
  updating: boolean,
  deleting: boolean,
  success: boolean,
  error: any,
  types: MergeValuesTypesType,
  rules: MergeValuesRulesByTypeType,
  scheduleSyncIn: number,
  scheduleSyncAfter: number,
  waitSyncAt: number
};
